/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PalReauthSubmissionStatus } from './PalReauthSubmissionStatus';
import {
    PalReauthSubmissionStatusFromJSON,
    PalReauthSubmissionStatusFromJSONTyped,
    PalReauthSubmissionStatusToJSON,
    PalReauthSubmissionStatusToJSONTyped,
} from './PalReauthSubmissionStatus';
import type { PalReauthSubmissionTimingState } from './PalReauthSubmissionTimingState';
import {
    PalReauthSubmissionTimingStateFromJSON,
    PalReauthSubmissionTimingStateFromJSONTyped,
    PalReauthSubmissionTimingStateToJSON,
    PalReauthSubmissionTimingStateToJSONTyped,
} from './PalReauthSubmissionTimingState';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
    PalReauthCaseManagerToJSONTyped,
} from './PalReauthCaseManager';
import type { PalReauthSubmissionListEntryTimExecution } from './PalReauthSubmissionListEntryTimExecution';
import {
    PalReauthSubmissionListEntryTimExecutionFromJSON,
    PalReauthSubmissionListEntryTimExecutionFromJSONTyped,
    PalReauthSubmissionListEntryTimExecutionToJSON,
    PalReauthSubmissionListEntryTimExecutionToJSONTyped,
} from './PalReauthSubmissionListEntryTimExecution';
import type { PalReauthNote } from './PalReauthNote';
import {
    PalReauthNoteFromJSON,
    PalReauthNoteFromJSONTyped,
    PalReauthNoteToJSON,
    PalReauthNoteToJSONTyped,
} from './PalReauthNote';
import type { PalReauthSubmissionMode } from './PalReauthSubmissionMode';
import {
    PalReauthSubmissionModeFromJSON,
    PalReauthSubmissionModeFromJSONTyped,
    PalReauthSubmissionModeToJSON,
    PalReauthSubmissionModeToJSONTyped,
} from './PalReauthSubmissionMode';
import type { PalReauthSubmissionListEntryLead } from './PalReauthSubmissionListEntryLead';
import {
    PalReauthSubmissionListEntryLeadFromJSON,
    PalReauthSubmissionListEntryLeadFromJSONTyped,
    PalReauthSubmissionListEntryLeadToJSON,
    PalReauthSubmissionListEntryLeadToJSONTyped,
} from './PalReauthSubmissionListEntryLead';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
    PalAuthSubmissionStatusUpdatedByUserToJSONTyped,
} from './PalAuthSubmissionStatusUpdatedByUser';
import type { PalReauthSubmissionListEntryPayer } from './PalReauthSubmissionListEntryPayer';
import {
    PalReauthSubmissionListEntryPayerFromJSON,
    PalReauthSubmissionListEntryPayerFromJSONTyped,
    PalReauthSubmissionListEntryPayerToJSON,
    PalReauthSubmissionListEntryPayerToJSONTyped,
} from './PalReauthSubmissionListEntryPayer';
import type { PalReauthSubmissionStatusInfo } from './PalReauthSubmissionStatusInfo';
import {
    PalReauthSubmissionStatusInfoFromJSON,
    PalReauthSubmissionStatusInfoFromJSONTyped,
    PalReauthSubmissionStatusInfoToJSON,
    PalReauthSubmissionStatusInfoToJSONTyped,
} from './PalReauthSubmissionStatusInfo';

/**
 * 
 * @export
 * @interface PalReauthSubmissionListEntry
 */
export interface PalReauthSubmissionListEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * The linked pre-auth. Null for a re-auth added manually to a lead with no pre-auth.
     */
    pal_submission_id: string | null;
    /**
     * 
     */
    status: PalReauthSubmissionStatus;
    /**
     * 
     */
    status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     */
    previous_status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     */
    external_id?: string | null;
    /**
     * 
     */
    next_review_date?: string | null;
    /**
     * 
     */
    timing_state: PalReauthSubmissionTimingState;
    /**
     * 
     */
    can_revert_status: boolean;
    /**
     * Last time the status was written or the remote status sync checked the payer portal. Null for cycles never submitted or edited since the column was added.
     */
    status_updated_at?: Date | null;
    /**
     * True while the automated submission's remote status sync is armed. Turned off by a terminal portal status, a portal miss, or a manual status change.
     */
    should_sync_remote_status?: boolean;
    /**
     * True when the payer portal is being checked for status updates: the cycle has an `external_id`, `should_sync_remote_status` is on, its pre-auth's platform supports re-auth status sync, and `status_updated_at` is within the sync window.
     */
    is_syncing_remote_status?: boolean;
    /**
     * True when this is the lead's active cycle and `pal_reauths` is on for the lead's facility, so the concurrent review must pass through the `review` status in the Re-Auth tab, where the submission package is built, before it can be Submitted. Inactive cycles are always false, since the wizard only works on the active cycle. While this is true, `PUT /pal-reauth-submissions/{id}` refuses `status=submitted` from `not_started`, `incomplete` or `review`; only `POST /pal-reauth-submissions/{id}/submit` sets it. Set on `GET /pal-reauth-submissions` rows and on the `latest_pal_reauth` of `GET /screener-leads/{lead_id}/pal-submission`. History rows and other responses leave it out.
     */
    requires_review_transition?: boolean;
    /**
     * True when this cycle's submission package has already been pushed to the lead's EHR. Set on the same responses as `requires_review_transition`.
     */
    is_submission_package_pushed_to_external_ehr?: boolean;
    /**
     * The patient's current note: the newest entry of the lead's note history across all cycles, including a `removed` entry. Null when the lead has no note history. Set on list rows, the latest re-auth and the single re-auth responses; history rows leave it out.
     */
    note?: PalReauthNote | null;
    /**
     * 
     */
    case_manager?: PalReauthCaseManager;
    /**
     * 
     */
    status_updated_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    submitted_at?: Date | null;
    /**
     * 
     */
    submitted_by_user_id?: string | null;
    /**
     * 
     */
    submitted_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    date_created: Date;
    /**
     * 
     */
    lead?: PalReauthSubmissionListEntryLead;
    /**
     * 
     */
    payer?: PalReauthSubmissionListEntryPayer;
    /**
     * 
     */
    auth_platform_name?: string | null;
    /**
     * 
     */
    is_oon?: boolean;
    /**
     * 
     */
    tim_execution?: PalReauthSubmissionListEntryTimExecution;
    /**
     * 
     */
    submission_mode?: PalReauthSubmissionMode;
    /**
     * 1-based re-auth cycle number for the lead (oldest cycle is 1)
     */
    cycle_number?: number;
}



/**
 * Check if a given object implements the PalReauthSubmissionListEntry interface.
 */
export function instanceOfPalReauthSubmissionListEntry(value: object): value is PalReauthSubmissionListEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('pal_submission_id' in value) || value['pal_submission_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('timing_state' in value) || value['timing_state'] === undefined) return false;
    if (!('can_revert_status' in value) || value['can_revert_status'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    return true;
}

export function PalReauthSubmissionListEntryFromJSON(json: any): PalReauthSubmissionListEntry {
    return PalReauthSubmissionListEntryFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'pal_submission_id': json['pal_submission_id'],
        'status': PalReauthSubmissionStatusFromJSON(json['status']),
        'status_info': json['status_info'] == null ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['status_info']),
        'previous_status_info': json['previous_status_info'] == null ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['previous_status_info']),
        'external_id': json['external_id'] === undefined ? undefined : json['external_id'] === null ? null : json['external_id'],
        'next_review_date': json['next_review_date'] === undefined ? undefined : json['next_review_date'] === null ? null : json['next_review_date'],
        'timing_state': PalReauthSubmissionTimingStateFromJSON(json['timing_state']),
        'can_revert_status': json['can_revert_status'],
        'status_updated_at': json['status_updated_at'] === undefined ? undefined : json['status_updated_at'] === null ? null : (parseDateTime(json['status_updated_at'])),
        'should_sync_remote_status': json['should_sync_remote_status'] == null ? undefined : json['should_sync_remote_status'],
        'is_syncing_remote_status': json['is_syncing_remote_status'] == null ? undefined : json['is_syncing_remote_status'],
        'requires_review_transition': json['requires_review_transition'] == null ? undefined : json['requires_review_transition'],
        'is_submission_package_pushed_to_external_ehr': json['is_submission_package_pushed_to_external_ehr'] == null ? undefined : json['is_submission_package_pushed_to_external_ehr'],
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : PalReauthNoteFromJSON(json['note']),
        'case_manager': json['case_manager'] == null ? undefined : PalReauthCaseManagerFromJSON(json['case_manager']),
        'status_updated_by_user': json['status_updated_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_updated_by_user']),
        'submitted_at': json['submitted_at'] === undefined ? undefined : json['submitted_at'] === null ? null : (parseDateTime(json['submitted_at'])),
        'submitted_by_user_id': json['submitted_by_user_id'] === undefined ? undefined : json['submitted_by_user_id'] === null ? null : json['submitted_by_user_id'],
        'submitted_by_user': json['submitted_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['submitted_by_user']),
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
        'lead': json['lead'] == null ? undefined : PalReauthSubmissionListEntryLeadFromJSON(json['lead']),
        'payer': json['payer'] == null ? undefined : PalReauthSubmissionListEntryPayerFromJSON(json['payer']),
        'auth_platform_name': json['auth_platform_name'] === undefined ? undefined : json['auth_platform_name'] === null ? null : json['auth_platform_name'],
        'is_oon': json['is_oon'] == null ? undefined : json['is_oon'],
        'tim_execution': json['tim_execution'] == null ? undefined : PalReauthSubmissionListEntryTimExecutionFromJSON(json['tim_execution']),
        'submission_mode': json['submission_mode'] == null ? undefined : PalReauthSubmissionModeFromJSON(json['submission_mode']),
        'cycle_number': json['cycle_number'] == null ? undefined : json['cycle_number'],
    };
}

export function PalReauthSubmissionListEntryToJSON(json: any): PalReauthSubmissionListEntry {
    return PalReauthSubmissionListEntryToJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryToJSONTyped(value?: PalReauthSubmissionListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'pal_submission_id': value['pal_submission_id'],
        'status': PalReauthSubmissionStatusToJSON(value['status']),
        'status_info': PalReauthSubmissionStatusInfoToJSON(value['status_info']),
        'previous_status_info': PalReauthSubmissionStatusInfoToJSON(value['previous_status_info']),
        'external_id': value['external_id'],
        'next_review_date': value['next_review_date'],
        'timing_state': PalReauthSubmissionTimingStateToJSON(value['timing_state']),
        'can_revert_status': value['can_revert_status'],
        'status_updated_at': value['status_updated_at'] == null ? value['status_updated_at'] : serializeDateTime(value['status_updated_at']),
        'should_sync_remote_status': value['should_sync_remote_status'],
        'is_syncing_remote_status': value['is_syncing_remote_status'],
        'requires_review_transition': value['requires_review_transition'],
        'is_submission_package_pushed_to_external_ehr': value['is_submission_package_pushed_to_external_ehr'],
        'note': PalReauthNoteToJSON(value['note']),
        'case_manager': PalReauthCaseManagerToJSON(value['case_manager']),
        'status_updated_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['status_updated_by_user']),
        'submitted_at': value['submitted_at'] == null ? value['submitted_at'] : serializeDateTime(value['submitted_at']),
        'submitted_by_user_id': value['submitted_by_user_id'],
        'submitted_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['submitted_by_user']),
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'lead': PalReauthSubmissionListEntryLeadToJSON(value['lead']),
        'payer': PalReauthSubmissionListEntryPayerToJSON(value['payer']),
        'auth_platform_name': value['auth_platform_name'],
        'is_oon': value['is_oon'],
        'tim_execution': PalReauthSubmissionListEntryTimExecutionToJSON(value['tim_execution']),
        'submission_mode': PalReauthSubmissionModeToJSON(value['submission_mode']),
        'cycle_number': value['cycle_number'],
    };
}

